<template>
  <div class="col-sm-12" :class="grid ? 'col-md-' + grid : 'col-md-12'">
    <div class="form-group mb-2">
      <label class="d-block font-weight-bold">
        {{ label }}
        <span v-if="required" class="text-danger">*</span>
        <span
          v-if="!item"
          class="small text-warning"
          style="font-size: 10px"
          v-b-tooltip.hover
          title="Campo vazio!"
          ><i class="fas fa-exclamation"></i
        ></span>
        <b-link
          v-if="alerta"
          href="#"
          @click.prevent="void 0"
          class="mb-2"
          variant="warning"
          v-b-popover.hover.top="alerta"
        >
          <i class="fas fa-alert-circle"></i>
        </b-link>
        <b-link
          v-if="ajuda"
          href="#"
          @click.prevent="void 0"
          class="mb-2"
          variant="info"
          v-b-popover.hover.top="ajuda"
        >
          <i class="fas fa-info-circle"></i>
        </b-link>
      </label>
      <v-select
        :options="array"
        :multiple="multiple"
        :required="required"
        :disabled="disabled || false"
        label="value"
        :reduce="(item) => item.id"
        v-model="item"
        v-on:input="item, $emit('input', item), $emit('change')"
        :placeholder="status ? placeholder : `${'DIGITE O NOME - '}` + label"
        :loading="loading"
      >
        <template #search="{ attributes, events }">
          <input
            class="vs__search"
            :required="required && !item"
            v-bind="attributes"
            v-on="events"
            :value="text"
            @input="(event) => (text = event.target.value)"
            :style="uppercase ? 'text-transform: uppercase' : ''"
          />
        </template>
        <template slot="option" slot-scope="option">
          <div class="d-center" v-html="option.value"></div>
        </template>
        <template slot="selected-option" slot-scope="option">
          <div class="selected d-center" v-html="option.value"></div>
        </template>
        <template v-slot:no-options="{ search, searching }">
          <template v-if="searching">
            <span class="text-sm text-muted p-3 small">
              {{
                msgNaoEncontrado
                  ? msgNaoEncontrado
                  : "Nada encontrado, quer cadastrar?"
              }}</span
            ><br />
            <h4 class="pb-0" v-if="uppercase">{{ search | toUpper }}</h4>
            <b class="d-block" v-else>{{ search }}</b>

            <button
              class="btn btn-success btn-sm"
              @click.prevent="cadastrarItem(search)"
            >
              Cadastrar
            </button>
          </template>

          <em style="opacity: 0.5" v-if="array.length == 0 && search == ''">
            Nenhum resultado encontrado.
          </em>
        </template>
      </v-select>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    "disabled",
    "value",
    "itens",
    "label",
    "grid",
    "required",
    "mt",
    "urlSearch",
    "multiple",
    "placeholder",
    "uppercase",
    "ajuda",
    "alerta",
    "loading",
    "msgNaoEncontrado",
  ],

  data() {
    return {
      item: { id: null, value: null },
      array: [],
      status: true,
      text: "",
    };
  },
  beforeMount() {
    this.item = this.value;
    if (Array.isArray(this.itens)) {
      this.array = this.itens;
    }
  },
  watch: {
    disabled(n, o) {
      if (n == false) {
        this.status = false;
      } else {
        this.status = true;
      }
    },
    value(n, o) {
      this.item = n;
    },
    itens(n, o) {
      this.array = n;
    },
    text: function (val) {
      this.text = val
        .normalize("NFD")
        .replace(/([\u0300-\u036f])/g, "")
        .replace(/([^\w]+|\s+)/g, "-")
        .replace(/\-+/g, " ")
        .toUpperCase();
      this.search = this.text;
    },
  },
  methods: {
    onSearch() {},
    cadastrarItem(search) {
      this.$emit("insert", search);
      this.text = "";
      this.search = "";
    },
  },
};
</script>
<style lang="css">
.vs__dropdown-menu {
  display: block;
  box-sizing: border-box;
  position: absolute;
  top: calc(100% - 1px);
  left: 0;
  z-index: 99 !important;
  padding: 5px 0;
  margin: 0;
  width: 100% !important;
  max-height: 350px;
  min-width: 160px;
  overflow-y: auto;
  box-shadow: 0px 3px 6px 0px rgb(0 0 0 / 15%);
  border: 1px solid rgba(60, 60, 60, 0.26);
  border-top-style: none;
  border-radius: 0 0 4px 4px;
  text-align: left;
  list-style: none;
  background: #fff;
}
</style>
